import { Article } from 'types/services/articles';

export const transformResource = (resource: Article) => {
  return {
    key: resource.id,
    ...resource,
    createdAt: resource.createdAt
      .slice(8, 10)
      .concat(
        '.',
        resource.createdAt.slice(5, 7),
        '.',
        resource.createdAt.slice(0, 4),
        ' - ',
        resource.createdAt.slice(11, 16),
      ), //DateTime.fromISO(resource.createdAt).toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS),
    updatedAt: resource.updatedAt
      .slice(8, 10)
      .concat(
        '.',
        resource.updatedAt.slice(5, 7),
        '.',
        resource.updatedAt.slice(0, 4),
        ' - ',
        resource.updatedAt.slice(11, 16),
      ), //DateTime.fromISO(resource.updatedAt).toLocaleString(DateTime.DATETIME_SHORT_WITH_SECONDS),
    author: resource.author ? `${resource?.author?.firstName} ${resource?.author?.lastName}` : null,
    status: resource.status,
    createdBy: `${resource?.author?.firstName} ${resource?.author?.lastName}`,
    numberOfHits: resource?.articleStatistics?.numberOfHits,
    external_link: articleUrl(resource),
    obituaryType: resource.type.name,
    obituaryFormat: resource.obituaryFormat?.name,
    note: resource.note,
    //billId: resource.billId,
    people_id: resource.people_id,
    city: resource.city,
    published_date: resource.published_date
      ?.toString()
      .slice(8, 10)
      .concat('.', resource.published_date.toString().slice(5, 7), '.', resource.published_date.toString().slice(0, 4)),
  };
};

export const articleUrl = (article: Article) => {
  let url = '';

  return url;
};
export const textTypes = [
  'Preuzeti tekst',
  'Tekst drugog novinara',
  'Agencijski tekst',
  'Autorski tekst',
  'Prevedeni tekst',
  'Promo tekst',
];
